(function($) {
  'use strict';
  $( document ).ready( function() {

    /**
     * Frontpage TagCloud
     */

    // get isotope object
    var $tag_grid = $('.tagcloud-grid-container').isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      transitionDuration: 0,
      layoutMode: 'packery',
      packery: {
        // use element for option
        columnWidth: '.grid-item-sizer'
      }
    });

    // reveal items on init
    var $tag_items = $tag_grid.find('.grid-item');
    $tag_grid.addClass( 'is-ready' )
             .isotope( 'revealItemElements', $tag_items );

    // setup tagcloud fittext
    if(  $('.tagcloud-grid-container').length > 0 && typeof $.fn.fitText === 'function') {

      $('.tagcloud-grid-container .grid-item.weight- .tag-name').fitText(0.8, {
        minFontSize: '16px',
        maxFontSize: '20px'
      });
      $('.tagcloud-grid-container .grid-item.weight-1 .tag-name').fitText(0.8, {
        minFontSize: '16px',
        maxFontSize: '20px'
      });
      $('.tagcloud-grid-container .grid-item.weight-2 .tag-name').fitText(0.8, {
        minFontSize: '20px',
        maxFontSize: '28px'
      });
      $('.tagcloud-grid-container .grid-item.weight-3 .tag-name').fitText(0.8, {
        minFontSize: '24px',
        maxFontSize: '34px'
      });
      $('.tagcloud-grid-container .grid-item.weight-4 .tag-name').fitText(0.8, {
        minFontSize: '32px',
        maxFontSize: '48px'
      });

      $tag_grid.isotope( 'layout' );

    }

    /**
     * Dossier isotope layout and filters
     */

    // get isotope object
    var $dossier_grid = $('.dossier-grid-container').isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      transitionDuration: 0,
      layoutMode: 'packery',
      packery: {
        // use element for option
        columnWidth: '.grid-item-sizer'
      },
      hiddenStyle: {
        opacity: 0
      },
      visibleStyle: {
        opacity: 1
      }
    });

    // reveal items on init
    var $dossier_items = $dossier_grid.find('.grid-item');

    // layout grid items after images have loaded
    $dossier_grid.addClass( 'is-ready' )
                 .isotope( 'revealItemElements', $dossier_items );

    // re-layout items after each image has been loaded
    $dossier_grid.find('img').on('load', function(e) {
      $dossier_grid.isotope( 'layout' );
    });
    /*$dossier_grid.imagesLoaded( function() {
      console.log('images loaded on init');
      $dossier_grid.isotope('layout');
    });*/


    // filter items on button click
    $('#dossier-content-filter').on( 'click', '.button', function(e) {

      e.preventDefault();

      if($(this).hasClass('active')) {
        return;
      }

      $(this).parent().find('.button').removeClass('active');
      $(this).addClass('active');
      var filterValue = $(this).attr('data-filter');
      $dossier_grid.isotope({ filter: filterValue });

      // show/hide no results message
      //$('.no-results-message').foundation('toggle');
      if ( !$dossier_grid.data('isotope').filteredItems.length ) {
        $('.no-results-message').show();
        $('.dossier-append-more').attr('disabled', true);
      } else {
        $('.no-results-message').hide();
        $('.dossier-append-more').removeAttr('disabled');
      }

      // nice try..., guess not an option here
      /*$dossier_grid.on('arrangeComplete', function(e, filteredItems) {
        handleLoadMoreDossierContent($('.dossier-append-more'));
      });*/

    });

    // load in all other assets as soon as the dossier page is loaded
    $(window).load(function () {
      if(script_options.dossier_id !== undefined) {
        loadMoreDossierContent(script_options.dossier_id);
      }
    });

    function loadMoreDossierContent(post_id) {

      if( post_id === undefined ) {
        return;
      }

      $.ajax({
        url: script_options.ajax_url,
        data: {
          action        :  'load_dossier_content',
          dossier_nonce :  script_options.dossier_ajax_nonce,
          post_id       :  post_id,
          offset        :  $dossier_grid.find('.grid-item').length
        },
        type: 'POST',
        success: function(response) {
          //console.log(response);
          if(response.success) {

            // add and lay out newly appended items
            var $items = $(response.data);
            $dossier_grid.append( $items )
                         .isotope( 'appended', $items );

            /*$dossier_grid.imagesLoaded().progress( function() {
              $dossier_grid.isotope( 'layout' );
            });*/
            /*$dossier_grid.imagesLoaded( function() {
              console.log('imagesloaded');
              $dossier_grid.isotope( 'layout' );
            });*/
            // need to use native load event to work with lazysizes
            $dossier_grid.find('img').on('load', function(e) {
              $dossier_grid.isotope( 'layout' );
            });

          } else {

            if(response.data === 'complete' && !$('.ajax-info-message').length) {
              $('#dossier-content-container').append($('<div class="ajax-info-message ajax-notice column row"><div class="callout" data-closable>Keine weiteren Einträge.<button class="close-button" aria-label="Hinweis ausblenden" type="button" data-close><span aria-hidden="true">&times;</span></button></div></div>'));
              var timer = new Foundation.Timer($('.ajax-info-message'), {duration: 2500, infinite: false}, function(elem) {
                $('.ajax-info-message').find('.close-button').trigger('click');
              });
              timer.start();
            } else if(!$('.ajax-error-message').length) {
              $('#dossier-content-container').append($('<div class="ajax-error-message ajax-notice column row"><div class="alert callout" data-closable>Fehler bei der Abfrage.<button class="close-button" aria-label="Hinweis ausblenden" type="button" data-close><span aria-hidden="true">&times;</span></button></div></div>'));
            }
          }
        },
        error: function(e) {
          if(!$('.ajax-error-message').length) {
            $('#dossier-content-container').append($('<div class="ajax-error-message column row"><div class="alert callout">Fehler bei der Abfrage.<button class="close-button" aria-label="Hinweis ausblenden" type="button" data-close><span aria-hidden="true">&times;</span></button></div></div>'));
          }
          console.log('failed loading more articles');
        },
        complete: function(request, status) {
        }
      });

    }

    // load more button, maybe deprecated
    $('.dossier-append-more').on( 'click', function(e) {
      e.preventDefault();
      handleLoadMoreDossierContent(this);
    });
    // maybe deprecated, if not, we could try to query posts from localStorage object/local array instead to make filtering work with pagination/loading more content...
    function handleLoadMoreDossierContent(obj) {

      var $button = $(obj),
          button_text = $button.html();

      // create new item elements

      var post_id = $button.data('post');
      if( post_id === undefined ) {
        return;
      }

      if( $button.attr('disabled') !== undefined ) {
        return;
      }

      // reset filter
      /*if( ! $('#dossier-content-filter .active').is( $('#dossier-content-filter .button').first() ) ) {
        $('#dossier-content-filter .button').first().trigger('click');
      }*/

      //console.log('overall offset: ' + $dossier_grid.find('.grid-item').length);
      //console.log('filter specific offset: ' + $dossier_grid.find('.grid-item:visible').length);

      $.ajax({
        url: script_options.ajax_url,
        data: {
          action        :  'load_dossier_content',
          dossier_nonce :  script_options.dossier_ajax_nonce,
          post_id       :  post_id,
          filter        :  $('#dossier-content-filter .active').data('filter'),
          offset        :  $dossier_grid.find('.grid-item:visible').length
        },
        type: 'POST',
        beforeSend: function() {
          // handle button state
          $button.attr('disabled', true);
          $button.html('<i class="fal fa-spinner-third fa-spin" aria-hidden="true"></i> <span>Lädt...</span>');
        },
        success: function(response) {
          //console.log('success loading more articles');
          //console.log(response);
          $('.ajax-notice').remove();
          if(response.success) {
            // remove any error messages first

            // add and lay out newly appended items
            var $items = $(response.data);
            $dossier_grid.append( $items )
                         .isotope( 'appended', $items );

            $dossier_grid.imagesLoaded().progress( function() {
              $dossier_grid.isotope( 'layout' );
            });
          } else {

            if(response.data === 'complete' && !$('.ajax-info-message').length) {
              if($('#dossier-content-filter .active').data('filter') === '*')
                $('.dossier-append-more').remove();

              $('#dossier-content-container').append($('<div class="ajax-info-message ajax-notice column row"><div class="callout" data-closable>Keine weiteren Einträge.<button class="close-button" aria-label="Hinweis ausblenden" type="button" data-close><span aria-hidden="true">&times;</span></button></div></div>'));
              var timer = new Foundation.Timer($('.ajax-info-message'), {duration: 2500, infinite: false}, function(elem) {
                $('.ajax-info-message').find('.close-button').trigger('click');
              });
              timer.start();
            } else if(!$('.ajax-error-message').length) {
              $('#dossier-content-container').append($('<div class="ajax-error-message ajax-notice column row"><div class="alert callout" data-closable>Fehler bei der Abfrage.<button class="close-button" aria-label="Hinweis ausblenden" type="button" data-close><span aria-hidden="true">&times;</span></button></div></div>'));
            }
          }
        },
        error: function(e) {
          if(!$('.ajax-error-message').length) {
            $('#dossier-content-container').append($('<div class="ajax-error-message column row"><div class="alert callout">Fehler bei der Abfrage.<button class="close-button" aria-label="Hinweis ausblenden" type="button" data-close><span aria-hidden="true">&times;</span></button></div></div>'));
          }
          console.log('failed loading more articles');
        },
        complete: function(request, status) {
          // handle button state
          $button.removeAttr('disabled');
          $button.html(button_text);
        }
      });

    }


  });

})( jQuery );
